// custom accordian PDP

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.acc-trigger');
  if (!btn) return;

  const item = btn.closest('.acc-item');
  const body = item.querySelector('.acc-body');
  const isOpen = item.classList.contains('acc-open');

  document.querySelectorAll('.acc-item').forEach(function (el) {
    el.classList.remove('acc-open');
    el.querySelector('.acc-trigger').setAttribute('aria-expanded', 'false');
    el.querySelector('.acc-body').style.maxHeight = null;
  });

  if (!isOpen) {
    item.classList.add('acc-open');
    btn.setAttribute('aria-expanded', 'true');
    body.style.maxHeight = body.scrollHeight + "px";
  }

});

  
  // custom video wrap PDP block 
  document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.video-card');
  let currentVideo = null;

  cards.forEach((card) => {
    const video = card.querySelector('video');
    const button = card.querySelector('.video-toggle');

    // Skip if elements don't exist
    if (!video || !button) return;

    card.addEventListener('click', function () {
      if (currentVideo === video) {
        if (video.paused) {
          video.play();
          button.style.display = 'none';
        } else {
          video.pause();
          button.style.display = 'flex';
        }
        return;
      }

      if (currentVideo && currentVideo !== video) {
        currentVideo.pause();

        const prevBtn = currentVideo.closest('.video-card')?.querySelector('.video-toggle');
        if (prevBtn) prevBtn.style.display = 'flex';
      }

      video.play();
      button.style.display = 'none';
      currentVideo = video;
    });

    video.addEventListener('pause', function () {
      button.style.display = 'flex';
    });

    video.addEventListener('ended', function () {
      button.style.display = 'flex';
      currentVideo = null;
    });
  });
});